export const sessionKeys = {
  all: ["session"] as const,
  me: () => [...sessionKeys.all, "me"] as const,
};

export const catalogKeys = {
  all: ["catalog"] as const,
  me: () => [...catalogKeys.all, "me"] as const,
};

/**
 * @deprecated Legacy profile queries retain their own cache shape until profile
 * consumers move to the session and catalog hooks.
 */
export const profileKeys = {
  all: ["profile"] as const,
  me: () => [...profileKeys.all, "me"] as const,
};
